export default {
  galleries: [],
  gallery: undefined,
  images: undefined,
};
